import { useFormContext } from '@calendly/form'
import { I18n } from '@calendly/i18n'
import { ControlledPlainTextEditor } from '@calendly/rich-text-editor'
import { useEffect } from 'react'

import { FieldBlock, Label } from './styles'
import ErrorMessage from '../../../core/error_message'
import { useTextField } from '../hooks/use_text_field'


export const EmailSubjectField = ({ errorMessage, ...props }) => {
  const fieldProps = useTextField(props)

  const { setFieldError } = useFormContext()

  useEffect(() => {
    setFieldError(fieldProps.name, '')
  }, [fieldProps.name, setFieldError, fieldProps.value])

  return (
    <FieldBlock data-component="subject_field_block">
      <Label htmlFor="subject">{I18n.t('publisher.contacts.share.email_form.subject')}</Label>
      <ControlledPlainTextEditor
        {...fieldProps}
        id="subject"
        hasError={Boolean(errorMessage)}
      />
      <ErrorMessage message={errorMessage} />
    </FieldBlock>
  )
}
